import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import {CommonDataService} from "../services/common-data.service";
import {ConfirmationService, Message} from "primeng/primeng";

import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";
import { ConfigService } from '../../config/config.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    isToggled: boolean = false;
    msgs: Message[] = [];

    @Output() toggled = new EventEmitter<boolean>();
    constructor(private userService: UserService,
        private configService : ConfigService,
        private sessionService: SessionService, private router: Router,
                private commonDataService: CommonDataService,
                private confirmationService: ConfirmationService
    ) {}

    ngOnInit() {}

    menuToggle() {
        this.isToggled = !this.isToggled;
        this.toggled.emit(this.isToggled);
    }

    submitChanges() {
        this.commonDataService.refreshView()
            .subscribe(
                data => {
                    this.msgs.push({ severity: 'success', detail: 'Changes are submitted successfully!' });
                    setTimeout(()=>{
                        this.msgs = [];
                    }, 3000);
                },
                error => {
                    console.log(error);
                    this.msgs.push({ severity: 'error', detail: error.message });
                    setTimeout(()=>{
                        this.msgs = [];
                    }, 3000);
                }
            );
    }


    logOut() {
        this.executeLogOut();
    }

    executeLogOut() {
        this.userService.userLogout()
            .subscribe(
                data => {
                    this.sessionService.destroySessionCookie(true);
                    
                    window.open(this.configService.appURI, "_self");
                    // window.open(this.configService.appURI, "_blank");
                    // window.top.close();
                    
                },
                error => {
                    this.sessionService.destroySessionCookie(true);
                    window.open(this.configService.appURI, "_self");
                    // window.open(this.configService.appURI, "_blank");
                    // window.top.close();
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts